export default __webpack_public_path__ + "static/media/saas-2.419b1c93.png";